// Shared Leads constants — single source of truth (no duplication across components).

export const STATUSES = ['new', 'contacted', 'interested', 'converted', 'rejected'] as const;

export const STATUS_LABELS: Record<string, string> = {
  new: 'New',
  contacted: 'Contacted',
  interested: 'Interested',
  converted: 'Converted',
  rejected: 'Rejected',
};

/** Sub-statuses available per main status (legacy parity). */
export const SUB_STATUSES: Record<string, string[]> = {
  contacted: ['Follow_Up_Scheduled', 'Left_Message', 'Requested_More_Info', 'No_Answer_Try_Again'],
  interested: ['Awaiting_Proposal', 'Reviewing_Terms', 'Price_Negotiation', 'Verbal_Agreement'],
  converted: ['Payment_Pending', 'Onboarding', 'Active_Client'],
  rejected: ['Not_Interested', 'Too_Expensive', 'Using_Competitor', 'No_Budget', 'Bad_Timing', 'Unreachable'],
};

/**
 * Backend-supported call dispositions (server.js validDispositions).
 * Values must match exactly; labels are display-only.
 */
export const CALL_DISPOSITIONS = [
  { value: 'talked', label: 'Connected / Spoke' },
  { value: 'no_answer', label: 'No Answer' },
  { value: 'busy', label: 'Busy' },
  { value: 'switched_off', label: 'Switched Off' },
  { value: 'not_reachable', label: 'Not Reachable' },
  { value: 'ringing', label: 'Ringing (no outcome)' },
] as const;

export const DISPOSITION_LABELS: Record<string, string> = Object.fromEntries(
  CALL_DISPOSITIONS.map((d) => [d.value, d.label]),
);
